import AnimationDelay from '../utils/AnimationDelay';
import swap from '../utils/swap';

const iParent = (i) => {
  return Math.floor((i-1)/2)
}
const iLeftChild = (i) => {
  return 2 * i + 1;
}
const iRightChild = (i) => {
  return 2 * i + 2;
}
const heapsort = async (a, lo, hi, delayController) => {
  await heapify(a, a.length, delayController);
  let end = a.length - 1;
  while (end > 0) {
    swap(a, end, 0, delayController);
    end = end - 1;
    await siftDown(a, 0, end, delayController)
  }
}
const heapify = async (a, l, delayController) => {
  let start = iParent(l - 1);
  while (start >= 0) {
    await siftDown(a, start, l - 1, delayController)
    start = start - 1;
  }
  return new Promise((r)=> {
    r();
  });
}
const siftDown = async (a, start, end, delayController) => {
  let root = start;
  while (iLeftChild(root) <= end) {
    const child = iLeftChild(root)
    let toSwap = root;
    if (a[toSwap] < a[child]) {
      toSwap = child;
    }
    if (child + 1 <= end && a[toSwap] < a[child + 1]) {
      toSwap = child + 1;
    }
    if (toSwap === root) {
      return;// done
    } else {
      swap(a, root, toSwap);
      root = toSwap;
    }
    await delayController.delay();
  }
  return new Promise((r) => {
    r();
  })
}
export default class HeapsortAlgorithm {
  constructor({delayController} = {}) {
    this.delayController = delayController || new AnimationDelay();
  }
  sort = async (a) => {
    await heapsort(a, 0, a.length - 1, this.delayController)
  }
}



// WEBPACK FOOTER //
// ./src/algorithms/heapsort.js